import ApiService from './ApiService';

class GenerateUploadUrlService {
  async generateCorporateDocument(payload = {}) {
    try {
      const response = await ApiService.call(
        '/secured/upload_corporate_account_opening_document',
        'POST',
        payload,
      );
      let data = response;

      return {
        uploadUrl: data.uploadUrl,
        success: true,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }

  async generateIndividualDocument(payload = {}) {
    try {
      const response = await ApiService.call(
        '/secured/upload_individual_account_opening_document',
        'POST',
        payload,
      );
      let data = response;

      return {
        uploadUrl: data.uploadUrl,
        success: true,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }
}
export default new GenerateUploadUrlService();
